import { render, staticRenderFns } from "./SingleLeader.vue?vue&type=template&id=b2321e20"
import script from "./SingleLeader.vue?vue&type=script&lang=js"
export * from "./SingleLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports